import { SearchScenarioId } from 'owa-search-next-common';
import { SuggestionSet } from 'owa-search-service';
import { action } from 'satcheljs';

/**
 * Dispatched by consumer when new suggestions have been processed and
 * are ready to display to the user.
 *
 * @param qfRequestId The ID of the QF request (generated by the client)
 */
const onSuggestionsProcessed = action(
    'onSuggestionsProcessed',
    (scenarioId: SearchScenarioId, suggestionSet: SuggestionSet, qfRequestId: string = null) => ({
        scenarioId,
        suggestionSet,
        qfRequestId,
    })
);

export default onSuggestionsProcessed;
